import {GET, POST} from "@/services/gateway";

const getBackedupItems = () => {
  return GET('dashboard/google/backup-events');
}

const list = (data) => {
  return POST('dashboard/google/backup-events', data);
}

const getBackupItems = () => {
  return GET('dashboard/google/backup-items');
}

export {
  getBackedupItems,
  list,
  getBackupItems,
}
